/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
class LoadingScreen {
  private json: any
  public readonly completeText: string;
  public readonly loadingText: string;

  constructor (json: any) {
    this.json = json
    this.completeText = json.complete_field
    this.loadingText = json.loading_text
  }

  static of (json: any): LoadingScreen {
    return new LoadingScreen(json)
  }
}

export default LoadingScreen
